import { useEffect, useState } from "react"
import { getTeamMembersVacationReport } from "../../../../../services/vacation.service"

export default function useFetchTeamMembersVacationsReport(refresh = false) {
  const [teamMembers, setTeamMembers] = useState(
    /** @type {Array<import("../VacationsReport.controller").TeamMemberVacationReport>} */ ([])
  )
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    let isMounted = true

    if (isMounted) {
      fetchTeamMembers()
    }

    return () => {
      isMounted = false
    }
  }, [refresh])

  async function fetchTeamMembers() {
    setIsLoading(true)
    const response = await getTeamMembersVacationReport().finally(() => {
      setIsLoading(false)
    })

    if (!response.success) return

    setTeamMembers(response.result)
  }

  return { teamMembers, isLoading }
}
